module.exports = __webpack_public_path__ + "static/w-lifesync-b11c0f416cc86703f333b5f0720e7b13.webp";